module.exports = __webpack_public_path__ + "files/f7418e6b0f492456888a0f1db0e94bf3.png";